/**
 * Borne de période stockée → `YYYY-MM-DD` pour un `<input type="date">`.
 *
 * Accepte l'ISO (`2026-09-10T00:00:00`) et le date-math Elasticsearch relatif
 * à maintenant (`now`, `now-30d`, `now-1M`, `now-7d/d`), que les pages posent
 * en défaut parce qu'un YAML n'a pas d'horloge. Sans ce décodage, l'input
 * restait VIDE alors que la requête filtrait bien sur 30 jours : l'écran
 * annonçait « toutes les dates » en en montrant un mois.
 *
 * @param {string} value
 *   La borne telle que le magasin la tient.
 * @param {Date} now
 *   L'instant de référence (injectable pour les tests).
 * @return {string}
 *   La date locale, ou '' pour une valeur illisible.
 */
export function boundToYmd(value, now = new Date()) {
  if (typeof value !== 'string') return ''
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10)

  const m = /^now(?:([+-])(\d+)([dwMy]))?(?:\/[dwMy])?$/.exec(value.trim())
  if (!m) return ''

  const d = new Date(now)
  if (m[1]) {
    const n = Number(m[2]) * (m[1] === '-' ? -1 : 1)
    if (m[3] === 'd') d.setDate(d.getDate() + n)
    else if (m[3] === 'w') d.setDate(d.getDate() + 7 * n)
    else if (m[3] === 'M') d.setMonth(d.getMonth() + n)
    else d.setFullYear(d.getFullYear() + n)
  }
  const pad = (x) => String(x).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
